import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-community-detail',
  templateUrl: './offline-community-detail.component.html',
  styleUrls: ['./offline-community-detail.component.scss']
})
export class OfflineCommunityDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
